import { createContext } from 'react';
import { Locale } from 'date-fns';
import { enUS } from 'date-fns/locale';
import getLocale from './localization';

const { COUNTRY, LANGUAGE } = CSS_CONFIG;

export type LocaleContextType = {
  locale: Locale;
};

const DefaultContext = {
  locale: getLocale(COUNTRY, LANGUAGE) || enUS,
};

const LocaleContext = createContext<LocaleContextType>(DefaultContext);

export default LocaleContext;
